import { render, staticRenderFns } from "./relatorioEventos.vue?vue&type=template&id=07dde57a"
import script from "./relatorioEventos.vue?vue&type=script&lang=js"
export * from "./relatorioEventos.vue?vue&type=script&lang=js"
import style0 from "./relatorioEventos.vue?vue&type=style&index=0&id=07dde57a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports